import { render } from "./LoginHistoryManage.vue?vue&type=template&id=604499f9"
import script from "./LoginHistoryManage.vue?vue&type=script&lang=js"
export * from "./LoginHistoryManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__